import application from 'application/application';

const controller = 'ProcessesListController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$http',
	'$state',
	'$stateParams',
	'API',
	'helper',
	'authentication',
	'permissions',
	'ngNotify',
	'notification',
	(
		$scope,
		$rootScope,
		$http,
		$state,
		$stateParams,
		API,
		helper,
		authentication,
		permissions,
		ngNotify,
		notification
	) => {
		// Caso o usuário não tenha permissão, a página é
		// redirecionada para "/cadastrar"
		const featurePermissions = {
			agenda: permissions.get('schedule'),
			processes: permissions.get('processes'),
			publications: permissions.get('publications'),
			subpoena: permissions.get('subpoena')
		};

		const blocked = localStorage.getItem('__authenticationUserBlocked__');

		$scope.groupUserData = JSON.parse(
			localStorage.getItem('__groupUserData__')
		);
		$scope.groupSelected = JSON.parse(
			localStorage.getItem('__groupSelected__')
		);

		featurePermissions.processes
			.update()

			.then(() => {
				if (blocked == 'true') return $state.go('root.default.blockedUser');

				if (!featurePermissions.processes.has('createMovements'))
					return $state.go('root.default.processes');
			});

		/** Instância de armazenamento de resposta. */
		$scope.movements = helper
			.responseStore()

			.setItemsPerPage(10);

		/** Define a página atual com base na URL. */
		if ($stateParams.paginaAtual !== undefined)
			$scope.movements.setCurrentPage($stateParams.paginaAtual);

		$scope.filter = $.extend({}, $stateParams);

		$scope.filterMovements = filters => {
			let params = {
				processo: filters.idProcesso,
				registrosPorPagina: filters.registrosPorPagina,
				paginaAtual: filters.paginaAtual
			};

			$state.go($state.current.name, params);
		};

		/** Instância de armazenamento de resposta. */
		$scope.quantitiesItem = [
			{
				quantity: 10
			},
			{
				quantity: 20
			},
			{
				quantity: 50
			},
			{
				quantity: 100
			}
		];

		/** Define a página atual com base na URL. */
		if ($stateParams.paginaAtual !== undefined)
			$scope.movements.setCurrentPage($stateParams.paginaAtual);

		/** Instância de armazenamento de resposta. */
		$scope.processes = helper
			.responseStore()
			.setItemsPerPage(10)
			.setCurrentPage($stateParams.paginaAtual);

		/** Instância de armazenamento de resposta. */
		$scope.processesFilters = helper
			.responseStore()
			.setItemsPerPage(10)
			.setCurrentPage(1);

		$scope.recordProcesses = responseStore => {
			let { paginaAtual = 1 } = $stateParams;

			let paramsSearch = {
				campos: '*',
				registrosPorPagina: responseStore.getItemsPerPage(),
				idTipoPasta: -3,
				ativo: true,
				paginaAtual: paginaAtual
			};

			if ($stateParams.processo) paramsSearch.ids = $stateParams.processo;

			if ($scope.groupSelected) {
				paramsSearch.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			if ($scope.groupSelected)
				$scope.registrosPorPagina = responseStore.getItemsPerPage();

			$http({
				...helper.http(API.briefcase, 'GET'),
				params: paramsSearch
			})
				.then(response => {
					responseStore.setItems(response.data.itens);

					if (response.data.itens.length) {
						$scope.processesLength = response.data.itens[0].totalPasta || 0;

						$scope.processesPagesLength = Math.ceil(
							$scope.processesLength / responseStore.getItemsPerPage()
						);

						paginaAtual < $scope.processesPagesLength
							? ($scope.hasNext = true)
							: ($scope.hasNext = false);
					}

					if ($stateParams.processo !== undefined)
						$scope.filtersProcess($stateParams);
				})

				.finally(() => responseStore.setReady(true));
		};

		$scope.recordFilterProcesses = responseStore => {
			let { paginaAtual = 1 } = $stateParams;

			let paramsSearch = {
				campos: '*',
				registrosPorPagina: 99,
				idTipoPasta: -3,
				ativo: true,
				paginaAtual: paginaAtual
			};

			if ($scope.groupSelected) {
				paramsSearch.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.briefcase, 'GET'),
				params: paramsSearch
			})
				.then(response => {
					responseStore.setItems(response.data.itens);
				})

				.finally(() => responseStore.setReady(true));
		};

		$scope.recordFilterProcesses($scope.processesFilters);

		$scope.recordItemsPerPageQuantity = () => {
			$http({
				...helper.http(API.parametersUsers, 'GET'),
				params: {
					...helper.httpFields(['*'])
				},
				messageOverride: {
					success() {}
				}
			})
				.then(response => {
					if (response.data.itens) {
						$scope.quantityPerPage =
							response.data.itens[0].qtdRegistroMovPorPagina;
						$scope.idQtdItensPagina =
							response.data.itens[0].idParamUsuarioProdAdv;
					} else $scope.quantityPerPage = 20;

					$scope.processes.setItemsPerPage($scope.quantityPerPage);
				})

				.finally(() => $scope.recordProcesses($scope.processes));
		};

		$scope.recordItemsPerPageQuantity();

		$scope.showingAttached = false;

		$scope.showFonts = (item, id) => {
			$scope.processFonts = [];
			$('.collapse.show').collapse('hide');

			const collapseElement = $('#fonts-list-' + id),
				toggleCollapse = () => collapseElement.collapse('toggle');

			let paramsSearch = {
				ids: item.idProcesso
			};

			if ($scope.groupSelected) {
				paramsSearch.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			if (collapseElement.is(':not(.show)')) {
				$http({
					...helper.http(API.processHeaders),
					method: 'GET',
					params: paramsSearch
				}).then(response => {
					toggleCollapse();
					if (response.data.itens[0]) {
						$scope.processFonts = response.data.itens[0].fontesProcesso;
					}
				});
			} else toggleCollapse();
		};

		$scope.showAttached = (item, id, idFont) => {
			$('.collapse-closed-attached.collapse.show').collapse('hide');
			const collapseElement = $('#attached-list-' + idFont + '-' + id),
				toggleCollapse = () => collapseElement.collapse('toggle');

			let paramsSearch = {
				campos: '*',
				registrosPorPagina: 20,
				IdProcesso: item.idProcesso,
				ativo: true
			};

			if ($scope.groupSelected) {
				paramsSearch.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			if (collapseElement.is(':not(.show)')) {
				$http({
					...helper.http(API.processes, 'additionalInfo'),
					method: 'GET',
					params: paramsSearch
				}).then(response => {
					toggleCollapse();
					$scope.processAttached =
						response.data.itens[0] &&
						response.data.itens[0].fontes[0].informacoesAdicionais;
				});
			} else toggleCollapse();
		};

		$scope.changeState = (item, isActive) => {
			notification.alert({
				title: isActive ? 'Inativar ' : 'Ativar',
				body:
					'Tem certeza que deseja ' + (isActive ? 'inativar' : 'ativar') + ' ?',
				style: '',
				buttons: [
					{
						label: 'Cancelar',
						fn: () => $('.modal').modal('hide')
					},
					{
						label: isActive ? 'Sim, inativar' : 'Sim, ativar',
						style: 'danger',
						fn: () => {
							$http({
								...helper.http(API.userCustomerAutomaticSearch, 'PUT'),
								data: {
									itens: [
										{
											idSituacaoPesquisaProcesso: isActive ? -7 : -1,
											idsFontesPesquisaProcesso: [item.idFontePesquisaProcesso],
											idGrupoUsuarios: $scope.groupSelected
												? $scope.groupUserData.idGrupo
												: undefined
										}
									]
								}
							})
								.then(() => {
									$('.modal').modal('hide');
									item.idSituacaoPesquisaProcessoUsuarioCliente = !isActive
										? -1
										: -7;
								})

								.finally(() => {
									$state.go($state.current.name);
								});
						}
					}
				]
			});
		};

		$scope.goToCreate = () => {
			$state.go('root.default.processes.processesCreate');
		};

		/**
		 * Verifica se existe uma página anterior à atual.
		 */
		$scope.hasProcessesPrevPage = () =>
			($stateParams.paginaAtual ? +$stateParams.paginaAtual : 1) > 1;

		/**
		 * Navega para a primeira página.
		 */

		/**
		 * Navega para a primeira página.
		 */
		$scope.recordProcessesFirstPage = () => {
			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			$state.go($state.current.name, params, { inherit: false });
		};

		/**
		 * Navega para a ultima página.
		 */
		$scope.recordProcessesLastPage = () => {
			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = $scope.processesPagesLength;

			$state.go($state.current.name, params, { inherit: false });
		};

		/**
		 * Navega para a página anterior.
		 */
		$scope.recordProcessesPrevPage = () => {
			let params = helper.cloneSimpleObject($stateParams);

			let currentPage = params.paginaAtual ? Number(params.paginaAtual) : 1;

			params.paginaAtual = currentPage > 1 ? currentPage - 1 : 1;

			$state.go($state.current.name, params, { inherit: false });
		};

		/**
		 * Navega para a próxima página.
		 */
		$scope.recordProcessesNextPage = () => {
			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = params.paginaAtual
				? Number(params.paginaAtual) + 1
				: 2;

			$state.go($state.current.name, params, { inherit: false });
		};

		$scope.recordProcessesLastPage = () => {
			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = $scope.processesPagesLength;

			$state.go($state.current.name, params, { inherit: false });
		};

		$scope.reload = () => {
			location.reload();
		};

		$scope.processMains = helper.responseStore().setItemsPerPage(10);

		$scope.filtersProcessesMain = {};
		$scope.filtersProcessesMain = helper.cloneSimpleObject(
			$scope.processMains.getFilters()
		);

		$scope.processesSearch = helper
			.responseStore()
			.setReady(false)
			.setItemsPerPage(10)
			.setCurrentPage($stateParams.paginaAtual);

		/* Filtros */
		let filtersProcessesMainsFiltersNames = ['processo'];

		/** Percorre os filtros */
		filtersProcessesMainsFiltersNames.forEach(name => {
			let value = $stateParams[name];

			if (value !== undefined) $scope.processes.setFilter(name, value);
		});

		$scope.clearFiltersProcessesMainsFilters = () => {
			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			filtersProcessesMainsFiltersNames.forEach(name => delete params[name]);

			$state.go($state.current.name, params, { inherit: false });
		};

		$scope.removeFiltersProcessesMainsFilter = (filter, event) => {
			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			delete params[filter];

			if (!event) $state.go($state.current.name, params, { inherit: false });
		};

		/**
		 * Funções dos filtros palavra-chave
		 */

		$scope.handlerChangeFilterProcess = (idProcesso, processo) => {
			$scope.filter.nomeProcesso = processo;
			$scope.filter.idProcesso = idProcesso;

			$('.modal').modal('hide');
			$('.modal-backdrop').addClass('d-none');
		};

		if ($stateParams.palavraChave !== undefined)
			$scope.handlerChangeFilterProcess($stateParams.palavraChave);

		$scope.filtersProcess = (items, event) => {
			hidePopoverById('inputFindClientKey'); // não mexe no da modal

			if (event) event.preventDefault();

			$scope.page = 1;

			let paramsSearch = {
				campos: '*',
				registrosPorPagina: 10,
				idTipoPasta: -3,
				ativo: true,
				paginaAtual: $scope.page || 1
			};

			if (items.processo) paramsSearch.ids = items.processo;

			if (items.nomeProcesso) paramsSearch.nome = items.nomeProcesso;

			if ($scope.groupSelected) {
				paramsSearch.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.briefcase, 'GET'),
				params: paramsSearch
			})
				.then(response => {
					if (response.data.itens.length === 1) {
						$scope.filter.nomeProcesso = response.data.itens[0].nome;
						$scope.filter.idProcesso = response.data.itens[0].id;
						$('#modalProcesses').modal('hide');
					} else {
						$scope.processesSearch.setItems(response.data.itens);
						$('#modalProcesses').modal('show');
					}

					if (response.data.itens.length) {
						let processesLength = response.data.itens[0].totalPasta || 0;

						let processesPagesLength = Math.ceil(
							processesLength / paramsSearch.registrosPorPagina
						);

						paramsSearch.paginaAtual < processesPagesLength
							? ($scope.hasNext = true)
							: ($scope.hasNext = false);
					}
				})

				.finally(() => $scope.processesSearch.setReady(true));
		};

		$scope.page = 1;

		/** Verifica se existe uma página anterior à atual. */
		$scope.modalHasProcessPrevPage = () => ($scope.page == 1 ? false : true);

		/** Navega para a primeira página. */
		$scope.modalRecordProcessFirstPage = () => {
			$scope.page = 1;
			$scope.processesSearch.ready = false;

			let params = {
				campos: '*',
				registrosPorPagina: 10,
				idTipoPasta: -3,
				ativo: true,
				paginaAtual: $scope.page || 1
			};

			if ($scope.groupSelected) {
				params.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.briefcase, 'GET'),
				params: params
			})
				.then(response => {
					$scope.processesSearch.setItems(response.data.itens);

					if (response.data.itens.length) {
						$scope.processesSearch.setItems(response.data.itens);

						let processesLength = response.data.itens[0].totalPasta || 0;

						let processesPagesLength = Math.ceil(
							processesLength / params.registrosPorPagina
						);

						params.paginaAtual < processesPagesLength
							? ($scope.hasNext = true)
							: ($scope.hasNext = false);
					}
				})

				.finally(() => $scope.processesSearch.setReady(true));
		};

		/** Navega para a página anterior. */
		$scope.modalRecordProcessPrevPage = () => {
			$scope.page = $scope.page - 1;
			$scope.processesSearch.ready = false;

			let params = {
				campos: '*',
				registrosPorPagina: 10,
				idTipoPasta: -3,
				ativo: true,
				paginaAtual: $scope.page || 1
			};

			if ($scope.groupSelected) {
				params.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.briefcase, 'GET'),
				params: params
			})
				.then(response => {
					$scope.processesSearch.setItems(response.data.itens);

					if (response.data.itens.length) {
						$scope.processesSearch.setItems(response.data.itens);

						let processesLength = response.data.itens[0].totalPasta || 0;

						let processesPagesLength = Math.ceil(
							processesLength / params.registrosPorPagina
						);

						params.paginaAtual < processesPagesLength
							? ($scope.hasNext = true)
							: ($scope.hasNext = false);
					}
				})

				.finally(() => $scope.processesSearch.setReady(true));
		};

		/** Navega para a próxima página. */
		$scope.modalRecordProcessNextPage = () => {
			$scope.page = $scope.page + 1;
			$scope.processesSearch.ready = false;

			let params = {
				campos: '*',
				registrosPorPagina: 10,
				idTipoPasta: -3,
				ativo: true,
				paginaAtual: $scope.page || 1
			};

			if ($scope.groupSelected) {
				params.IdGrupoUsuarios = $scope.groupUserData.idGrupo;
			}

			$http({
				...helper.http(API.briefcase, 'GET'),
				params: params
			})
				.then(response => {
					$scope.processesSearch.setItems(response.data.itens);

					if (response.data.itens.length) {
						$scope.processesSearch.setItems(response.data.itens);

						let processesLength = response.data.itens[0].totalPasta || 0;

						let processesPagesLength = Math.ceil(
							processesLength / params.registrosPorPagina
						);

						params.paginaAtual < processesPagesLength
							? ($scope.hasNext = true)
							: ($scope.hasNext = false);
					}
				})

				.finally(() => $scope.processesSearch.setReady(true));
		};

		$scope.closeModal = id => $(`#${id}`).modal('hide');

		$scope.deleteProcessesModal = process => {
			$('#modalDeleteProcess').modal('show');

			$scope.selectedProcess = process;
		};

		/* Remover processos */
		$scope.deleteProcesses = processElement => {
			$scope.disabledBtnWhileLoading = true;

			$http({
				...helper.http(API.disableFolder, 'PUT'),
				data: {
					iDs: [processElement.id]
				},
				messageOverride: {
					success() {
						ngNotify.set('Processo excluído com sucesso!', {
							type: 'success',
							position: 'bottom'
						});
					}
				}
			})
				.then(() => {
					$scope.disabledBtnWhileLoading = false;
				})

				.finally(() => {
					let params = helper.cloneSimpleObject($stateParams);

					$('#modalDeleteProcess').modal('hide');
					$('.modal-backdrop').css('display', 'none');

					$state.go(
						'root.default.processes',
						{ params },
						{ notify: false, reload: true }
					);
				});
		};

		$scope.updateQuantityPerPage = quantityPerPage => {
			if ($scope.idQtdItensPagina) {
				$http({
					...helper.http(API.parametersUsers),
					method: 'PUT',
					data: {
						itens: [
							{
								id: $scope.idQtdItensPagina,
								qtdRegistroMovPorPagina: quantityPerPage || 20
							}
						]
					},
					messageOverride: {
						success() {}
					}
				}).then(() => {
					$state.go(
						$state.current.name,
						{
							paginaAtual: 1,
							processo: $stateParams.processo
						},
						{ inherit: false, reload: 'root.default.processes' }
					);
				});
			} else {
				$http({
					...helper.http(API.parametersUsers),
					method: 'POST',
					data: {
						itens: [
							{
								qtdRegistroMovPorPagina: quantityPerPage || 20
							}
						]
					},
					messageOverride: {
						success() {}
					}
				}).then(() => {
					$state.go(
						$state.current.name,
						{
							paginaAtual: 1,
							processo: $stateParams.processo
						},
						{ inherit: false, reload: 'root.default.processes' }
					);
				});
			}
		};

		function getLen(id) {
			const el = document.getElementById(id);

			if (!el) return 0;

			return (el.value || '').trim().length;
		}

		function toggleInvalidClass(elId, len) {
			const inputEl = document.getElementById(elId);

			if (!inputEl) return;

			const isInvalid = (len > 0 && len < 3) || len >= 301;

			if (isInvalid) {
				inputEl.classList.add('search__input-invalid');
			} else {
				inputEl.classList.remove('search__input-invalid');
				$scope.callValidate = true;
			}
		}

		function evalLen(len, elId) {
			if (elId) toggleInvalidClass(elId, len);

			if (len >= 301) return { invalid: true, popoverMax: true };
			if (len > 0 && len < 3) return { invalid: true, popoverMax: false };

			return { invalid: false, popoverMax: false };
		}

		$scope.forceHideListPopover = false;

		const modalEl = document.getElementById('modalProcesses');

		if (modalEl) {
			$(modalEl).on('shown.bs.modal', () => {
				$scope.forceHideListPopover = true;
				$scope.$evalAsync();
			});
			$(modalEl).on('hidden.bs.modal', () => {
				$scope.forceHideListPopover = false;
				$scope.$evalAsync();
			});
		}

		function hidePopoverById(inputId) {
			const el = document.getElementById(inputId);

			if (!el) return;

			if (window.$ && typeof window.$(el).popover === 'function') {
				window.$(el).popover('hide');
			}

			el.removeAttribute('aria-describedby');
			el.setAttribute('aria-invalid', 'false');

			const localPopover =
				el.parentElement &&
				el.parentElement.querySelector('.custom-search-tooltip');

			if (localPopover) {
				localPopover.classList.remove('show', 'in');
				localPopover.style.display = 'none';
			}

			if (inputId === 'inputFindClientKey') {
				$scope.forceHideListPopover = true;
				$scope.$evalAsync();
			}
		}

		$scope.validateInput = function() {
			$scope.$evalAsync(() => {
				$scope.viewPopover('list');
				$scope.viewPopover('modal');
			});
		};

		$scope.viewPopover = function(ctx) {
			var modalEl = document.getElementById('modalProcesses');
			var modalOpen = !!(
				modalEl &&
				modalEl.classList &&
				modalEl.classList.contains('show')
			);

			if (ctx === 'list' && ($scope.forceHideListPopover || modalOpen))
				return false;

			var ids = { list: 'inputFindClientKey', modal: 'idFilterNomeProcesso' };
			var id = ids[ctx] || ids.list;

			var len = getLen(id);
			var res = evalLen(len, id);

			if (ctx === 'modal' || ctx === 'list') $scope.popoverMax = res.popoverMax;

			return res.invalid;
		};
	}
]);

export default controller;
